import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function ItemPartner({ item }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="grid grid-cols-12 px-4 py-3 flex items-center bg-gray-100 text-sm">
        <div className="col-span-12 text-left mb-3 text-lg font-bold">
          <Link
            to={"/settings/partners/" + item.partner.id}
            className="cursor-pointer hover:scale-110 "
          >
            {item.partner.name}
          </Link>
        </div>

        <div className="col-span-12 font-bold">
          {t("partnerContact.main")} :
        </div>
        <div className="col-span-12 text-left">
          {
            Object.values(
              item.partner.partnerContacts?.filter((c) => c.main === true)
            )[0]?.firstName
          }{" "}
          {
            Object.values(
              item.partner.partnerContacts?.filter((c) => c.main === true)
            )[0]?.lastName
          }
        </div>
        <div className="col-span-12 text-left">
          {
            <a
              href={`mailto:${
                Object.values(
                  item.partner.partnerContacts?.filter((c) => c.main === true)
                )[0]?.email
              }`}
              className="hover:underline"
            >
              {
                Object.values(
                  item.partner.partnerContacts?.filter((c) => c.main === true)
                )[0]?.email
              }
            </a>
          }
        </div>
        <div className="col-span-12 text-left">
          {
            Object.values(
              item.partner.partnerContacts?.filter((c) => c.main === true)
            )[0]?.phoneNumber
          }
        </div>
      </div>
    </>
  );
}

export default ItemPartner;
